import React from 'react';
import CountryPriceComparisonGraph from './CountryPriceComparisonGraph';

export default function GlobalPriceIntelligence({ data }) {
  return <CountryPriceComparisonGraph data={data} />;
}
